import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Deployments = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">⚙️ Deployments</h1>
          <p className="text-muted-foreground">Recent pushes, pipeline status</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Deployments Dashboard</CardTitle>
            <CardDescription>Recent pushes, pipeline status</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Deployments content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Deployments;